export default __webpack_public_path__ + "static/media/ren.0c190ff5.png";